import { render, staticRenderFns } from "./spike-data.vue?vue&type=template&id=27e64086&scoped=true&"
import script from "./spike-data.vue?vue&type=script&lang=js&"
export * from "./spike-data.vue?vue&type=script&lang=js&"
import style0 from "./spike-data.vue?vue&type=style&index=0&id=27e64086&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e64086",
  null
  
)

export default component.exports